import { fetchPosService } from "../fetchPosService";
import type {
  GetOrCreateCartForClerkMutation,
  GetOrCreateCartForClerkMutationVariables,
} from "../generates";
import { GetOrCreateCartForClerkDocument } from "../types";

export const getGetOrCreateCartForClerkyKeys = (
  store?: string,
  orderNumber?: string,
) => ["getOrCreateCartForClerk", store, orderNumber];

export type GetOrCreateCartForClerkProps = {
  storeCode?: string;
};

export const getOrCreateCartForClerk = async ({
  storeCode,
}: GetOrCreateCartForClerkProps): Promise<GetOrCreateCartForClerkMutation> => {
  return fetchPosService<
    GetOrCreateCartForClerkMutation,
    GetOrCreateCartForClerkMutationVariables
  >({
    query: GetOrCreateCartForClerkDocument,
    variables: {},
    store: storeCode,
  });
};
